import React from "react";
import { useSelector } from "react-redux";
import { Container, Typography, Button, Divider, Box } from "@mui/material";
import "./Hero.css";
import { t } from "../../utils/i18n";
import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext";
const Hero = () => {
  const { item, product_code, status } = useSelector((state) => state.products);
  const lang = useSelector((state) => state.i18n.lang);
  const { mode } = useContext(ThemeContext);
  const isArabic = lang === "ar";
  if (!item) return null;
  const gradient = `
    linear-gradient(
      ${isArabic ? "225deg" : "135deg"},
      rgba(251, 199, 184, 1) 30%,
      rgba(245, 218, 210, 0.6) 40%,
      rgba(219, 191, 186, 0.4) 70%,
      rgba(209, 96, 96, 0.2) 100%
    )
  `;

  const darkGradient = `
    linear-gradient(
      ${isArabic ? "225deg" : "135deg"},
      rgba(45, 45, 45, 1) 30%,
      rgba(30, 30, 30, 0.9) 60%,
      rgba(15, 15, 15, 0.8) 100%
    )
  `;

  return (
      <Box
        sx={{
          position: "relative",
          padding: { xs: "80px 0", md: "120px 0" },
          textAlign: isArabic ? "center" : "center",
          width: "90%",
          margin: "20px auto",
          mb: 3,
          borderRadius: "40px !important",
          overflow: "hidden",
          background: mode === "light" ? gradient : darkGradient,
          backgroundBlendMode: "overlay",
        }}
      >
       <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundImage: `url(https://dolftech.com/storage/products/${item?.hero_image})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: isArabic ? "right center" : "right center",
            transform: isArabic ? "scaleX(-1)" : "none",
            zIndex: 0,
            borderRadius: "40px",
            pointerEvents: "none",
          }}
        />
       <Container
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: isArabic ? "center" : "center",
            maxWidth: "md",
          }}
        >
        <Typography
          variant="h1"
          sx={{
            background:
              "linear-gradient(90deg, #FF6B6B 0%, #E97CB4 50%, #8C76DD 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: "inline-block",
          }}
        >
          {t(lang, "features.naahell")}
        </Typography>
        <Typography variant="h1" sx={{marginBottom: "8px"}}>
          {lang === "ar" ? item?.subline_ar : item?.subline}
        </Typography>
        <Typography
          variant="h2"
          fontWeight={400}
          dangerouslySetInnerHTML={{
            __html: lang === "ar" ? item?.description_ar : item?.description,
          }}
        />

        <Divider
          sx={{
            mt: 3,
            mb: 1,
            borderColor: mode === "light" ? "#020202ff" : "#ffffffff",
            width: 80,
            mx: "auto",
          }}
        />
        <Typography variant="h4" fontWeight={500} mb={5} letterSpacing={2}>
          {t(lang, "hero.title")}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            const el = document.getElementById("why-naahelcyber");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          sx={{
            backgroundColor: mode === "light" ? "black" : "white",
            color: mode === "light" ? "white" : "black",
            textTransform: "uppercase",
            wordSpacing: 3,
            letterSpacing: 4,

            borderRadius: 100,
            px: 5,
            py: 1.5,
            minWidth: "auto",
            "&:hover": {
              backgroundColor:
                mode === "light"
                  ? "rgba(0, 0, 0, 0.9)"
                  : "rgba(236, 236, 236, 0.9)",
            },
            "&:active": {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
            "& .MuiButton-label": {
              fontWeight: "bold",
            },
          }}
        >
          <Typography variant="h3" fontWeight={500} letterSpacing={2}>
            {lang === "ar" ? item?.button_text_ar : item?.button_text}
          </Typography>
        </Button>
      </Container>
    </Box>
  );
};

export default Hero;
